'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/function.prototype.name/polyfill.js
// module id = 482
// module chunks = 0